import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/services/authGuard.service';
import { AdminLayoutComponent } from 'app/theme/admin-layout/admin-layout.component';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    component: AdminLayoutComponent
    , children: [
      {
        path: ''
        //component: AdminLayoutComponent
        , children: [
          // {},
          {
            path: 'createauditprogram',
            loadChildren: () => import('app/components/createaudit/createaudit.module').then(m => m.CreateauditModule),
            data: { title: 'Create Audit Program', titleI18n: 'Create Audit Program' },
          },
          {
            path: 'auditprogramlist',
            loadChildren: () => import('app/components/auditprogramlist/auditprogramlist.module').then(m => m.AuditprogramlistModule),
            data: { title: 'Audit Program List', titleI18n: 'Audit Program List' },
          },
          {
            path: 'masters',
            loadChildren: () => import('app/components/masters/masters.module').then(m => m.MastersModule),
            data: { title: 'Masters', titleI18n: 'Masters' },
          },
          {
            path: 'auditorbench',
            loadChildren: () => import('app/components/auditorbench/auditorbench.module').then(m => m.AuditorbenchModule),
            data: { title: 'Auditor Bench', titleI18n: 'Auditor Bench' },
          },
          {
            path: 'approver',
            loadChildren: () => import('app/components/approver/approver.module').then(m => m.ApproverModule),
            data: { title: 'Approver', titleI18n: 'Approver' },
          },
          {
            path: 'audit-planning',
            loadChildren: () => import('app/components/audit-planning/audit-planning.module').then(m => m.AuditPlanningModule),
            data: { title: 'Audit Planning', titleI18n: 'Audit Planning' },
          },
          {
            path: 'auditorhome',
            loadChildren: () => import('app/components/auditorhome/auditorhome.module').then(m => m.AuditorhomeModule),
            data: { title: 'Auditor Home', titleI18n: 'Auditor Home' },
          },
          {
            path: 'auditeehome',
            loadChildren: () => import('app/components/auditeehome/auditeehome.module').then(m => m.AuditeehomeModule),
            data: { title: 'Auditee Home', titleI18n: 'Auditee Home' },
          },
          {
            path: 'auditeebench',
            loadChildren: () => import('app/components/auditeebench/auditeebench.module').then(m => m.AuditeebenchModule),
            data: { title: 'Auditee Bench', titleI18n: 'Auditee Bench' },
          },
          {
            path: 'usermaintenance',
            loadChildren: () => import('app/components/usermaintenance/usermaintenance.module').then(m => m.UsermaintenanceModule),
            data: { title: 'User Maintenance', titleI18n: 'User Maintenance' },
          },
          {
            path: 'workspace',
            loadChildren: () => import('app/components/workspace/workspace.module').then(m => m.WorkspaceModule),
            data: { title: 'Workspace', titleI18n: 'Workspace' },
          },

          {
            path: 'Admin',
            loadChildren: () => import('app/components/admin/admin.module').then(m => m.AdminModule),
            data: { title: 'Admin', titleI18n: 'Admin' },
          },
          {
            path: 'sessions',
            loadChildren: () => import('app/components/sessions/sessions.module').then(m => m.SessionsModule),
            data: { title: 'Sessions', titleI18n: 'sessions' },
          },
          {
            path: 'Report',
            loadChildren: () => import('app/components/reports/reports.module').then(m => m.ReportsModule),
            data: { title: 'Report', titleI18n: 'Report' },
          }
        ]
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
